import { createAsyncThunk } from '@reduxjs/toolkit';
import { IChecklistResponseDetails } from 'interfaces/checklist.interface';
import apiFetch from 'services/apiFetch';
import { getChecklistResponses } from 'services/checklistEndPoints';

export const fetchChecklistResponses = createAsyncThunk(
  'checklist/fetchResponses',
  async (id: string) => {
    try {
      const endpoint = getChecklistResponses(id);
      const resp = await apiFetch<IChecklistResponseDetails[]>(endpoint).then(
        (res) => res?.data || null
      );
      return resp;
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      throw Error(message);
    }
  }
);
